
import React, { useState } from 'react';

export default function ForgotPasswordModal({ onClose }) {
  const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!identifier) {
      setError('Por favor, introduce tu correo o número de documento.');
      return;
    }

    try {
        const postData = { email: identifier };
        console.log("Enviando datos para restablecer contraseña:", postData);
        const response = await fetch(`/api/forgot-password`, {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      });

      const data = await response.json();
      console.log("Respuesta del servidor:", data);

      if (response.ok) {
        setMessage(data.message);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError('Error de conexión con el servidor.');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="bg-white p-10 rounded-2xl shadow-xl w-full max-w-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-800 text-2xl font-bold"
        >
          &times;
        </button>
        <h2 className="text-2xl font-bold text-center mb-4 text-primary">Restablecer Contraseña</h2>
        <p className="text-center text-gray-500 mb-6">
          Por favor escriba el correo electronico asociado a su usuario. Se enviara un vinculo de restablecimiento de contraseña al correo electrónico.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="identifier" className="block text-gray-700 font-medium mb-2">
              Correo electrónico
            </label>
            <input
              type="text"
              id="identifier"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-accent outline-none"
              placeholder="ej: correo@example.com"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-lime text-white font-bold py-3 rounded-lg hover:bg-primary transition-all duration-300"
          >
            ENVIAR
          </button>
        </form>
        {message && <p className="mt-4 text-center text-sm font-medium text-green-600 bg-green-100 p-3 rounded-lg">{message}</p>}
        {error && <p className="mt-4 text-center text-sm font-medium text-red-600 bg-red-100 p-3 rounded-lg">{error}</p>}
      </div>
    </div>
  );
}

